import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility } from '../../utilities/styles';

export class AllInLoader extends LitElement {
    static properties = {
        loading: {type: Boolean},
        height: {type: String},
    }

    constructor() {
        super();
    }

    

    render() {
        if(this.loading){
            if(this.height){
                return html`<div class="loading" aria-live="polite" style="min-height:${this.height}"><span class="loading_message">${msg(`Please wait. Loading`)}</span><span>.</span></div>`;
            }
            return html`<div class="loading" aria-live=polite><span class="loading_message">${msg(`Please wait. Loading`)}</span><span>.</span></div>`;
        }
        else{
            return html``;
        }
    }

    static styles = [
        accessibility,
        css`
        .loading{
            display:flex;
            gap:0.5rem;
            align-items:center;
            justify-content:center;
            padding:2rem;
            background-color:var(--allin-bg-color,#ccc);
            min-height:20rem;
            margin:2rem 0;

        }

        .loading_message + span {
            display: none;
        }

        .loading::after {
            content: '';
            display: block;
            width: 2rem;
            height: 2rem;
            animation: spin 1s linear infinite;
            z-index: 100;
            background-image: url(/wp-content/themes/ace/assets/wheel.svg);
            background-size: cover;
        }

        @keyframes spin {
            from { transform: rotate(0deg); }
            to   { transform: rotate(360deg); }
        }
        `
    ];
}